import { useMutation } from '@apollo/react-hooks';
import { Dialog } from 'primereact/dialog';
import React, { useContext } from 'react';
import { AccountContext } from '../../../../components/AccountContext';
import { NotificationContext } from '../../../../components/GrowlNotifications';
import { growlErrors } from '../../../../utils/NotificationUtil';
import { defineMessages, useIntl } from 'react-intl';
import { notificationMessages } from '../../../../i18n/common';
import { SUPER_MATCH_REQUEST_CONTACT_MUTATION } from '../../services/super-match.service';
import { Formik } from 'formik';
import SuperMatchContactRequestForm from './SuperMatchContactRequestForm';
import {
  buildSuperMatchContactRequestFormInitialValues,
  buildSuperMatchContactRequestFormValidationSchema,
} from '../../helpers/super-match.helper';
import moment from 'moment';

const messages = defineMessages({
  header: {
    id: 'account.super-matches.contact-request-dialog.header',
    defaultMessage: 'Request SuperMatch contact',
  },
  subHeader: {
    id: 'account.super-matches.contact-request-dialog.sub-header',
    defaultMessage: 'Contact response deadline',
  },
});

const SuperMatchContactRequestDialog = ({ superMatchId, hide }) => {
  const currentAccount = useContext(AccountContext);
  const growl = useContext(NotificationContext);
  const { formatMessage } = useIntl();

  const [requestContactMutation] = useMutation(SUPER_MATCH_REQUEST_CONTACT_MUTATION, {
    refetchQueries: ['superMatchListQuery'],
  });

  const requestContact = async ({ contactRequestDeadline }) => {
    const contactRequestDeadlineDate = new Date(
      Date.UTC(
        contactRequestDeadline.getFullYear(),
        contactRequestDeadline.getMonth(),
        contactRequestDeadline.getDate(),
      ),
    );

    const deadline = moment(contactRequestDeadlineDate).format('YYYY-MM-DD');

    try {
      await requestContactMutation({
        variables: {
          input: {
            id: superMatchId,
            accountId: currentAccount,
            contactRequestDeadline: deadline,
          },
        },
      });

      growl.show({ severity: 'info', detail: formatMessage(notificationMessages.success) });
      hide();
    } catch (error) {
      growlErrors(growl);
    }
  };

  const header = <div className="dashboard-panel-header">{formatMessage(messages.header)}</div>;

  const initialValues = buildSuperMatchContactRequestFormInitialValues();
  const validationSchema = buildSuperMatchContactRequestFormValidationSchema();

  return (
    <Dialog visible={!!superMatchId} onHide={hide} header={header} modal>
      <div className="mt20 align-center">
        <h3>{formatMessage(messages.subHeader)}</h3>
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={(values) => {
            requestContact(values);
          }}
        >
          <SuperMatchContactRequestForm />
        </Formik>
      </div>
    </Dialog>
  );
};

export default SuperMatchContactRequestDialog;
